export default function(){
    $(function () {
        $("#sl-js-select-monitor").on('change', function () {
            $("#sl-js-monitor-selector-form").trigger('submit');
        });
    });
}